<template>
  <v-app>
    <v-app-bar
      app
      color="white"
    >
      <div class="d-flex align-center">
        <router-link to="/">
          <v-img
            alt="DoleFund Logo"
            class="shrink mr-2"
            contain
            src="./assets/df-logo.png"
            transition="scale-transition"
            width="100"
          />
        </router-link>
      </div>

      <v-spacer></v-spacer>

      <v-btn
        to="/organizations"
        text
      >
        <span class="mr-2">Browse</span>
      </v-btn>
      <v-btn
        to="/login"
        text
      >
        <span class="mr-2">Log In</span>
      </v-btn>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import Footer from './components/Footer';

export default {
  name: 'App',

  components: {
    Footer,
  },

  data: () => ({
    //
  }),
};
</script>
